import { GetOption } from '../interfaces/components/options'

export const getOption: GetOption = (id, options) => {
  if (id in options[0]) {
    return options[0][id]
  } else {
    return options[1]
  }
}
